/**
 * @author skit1169
 * */

/**
 * Action Types
 */
export const FETCH_AGREEMENT_DATA = 'FETCH_AGREEMENT_DATA';
export const RECEIVE_AGREEMENT_DATA = 'RECEIVE_AGREEMENT_DATA';

export const FETCH_AGREEMENT_LIST = 'FETCH_AGREEMENT_LIST';
export const RECEIVE_AGREEMENT_LIST = 'RECEIVE_AGREEMENT_LIST';

export const RESET_AGREEMENT_DATA = 'RESET_AGREEMENT_DATA';
export const RECEIVE_ERROR_IN_AGREEMENT_FETCH = 'RECEIVE_ERROR_IN_AGREEMENT_FETCH';
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';

export const FETCH_AGREEMENTS_SEARCH_DATA = 'FETCH_AGREEMENTS_SEARCH_DATA';
export const RECEIVE_AGREEMENTS_SEARCH_DATA = 'RECEIVE_AGREEMENTS_SEARCH_DATA';
export const RESET_AGREEMENTS_SEARCH_DATA = 'RESET_AGREEMENTS_SEARCH_DATA';

export const FETCH_VENDOR_BASES = 'FETCH_VENDOR_BASES';
export const RECEIVE_VENDOR_BASES = 'RECEIVE_VENDOR_BASES';

export const FETCH_BUSINESS_CENTERS = 'FETCH_BUSINESS_CENTERS';
export const RECEIVE_BUSINESS_CENTERS = 'RECEIVE_BUSINESS_CENTERS';

export const FETCH_SAS_FD_DETAILS = 'FETCH_SAS_FD_DETAILS';
export const RECEIVE_SAS_FD_DETAILS = 'RECEIVE_SAS_FD_DETAILS';

export const SAVE_SAS_VALUE_FOR_VENDOR = 'SAVE_SAS_VALUE_FOR_VENDOR';
export const RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR = 'RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR';

export const REQUEST_SAS_FD_FILE_IMPORT = 'REQUEST_SAS_FD_FILE_IMPORT';
export const RECEIVE_SAS_FD_FILE_IMPORT = 'RECEIVE_SAS_FD_FILE_IMPORT';

export const ADD_SAS_VALUE_FOR_VENDOR = 'ADD_SAS_VALUE_FOR_VENDOR';
export const RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR = 'RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR';

export const SAVE_SAS_FD_DETAILS_FOR_ITEM = 'SAVE_SAS_FD_DETAILS_FOR_ITEM';
export const RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM = 'RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM';

export const CLEAR_AGREEMENT_DETAILS = 'CLEAR_AGREEMENT_DETAILS';

export const FETCH_EXCEPTIONS = 'FETCH_EXCEPTIONS';
export const RECEIVE_WHSE_EXCEPTIONS = 'RECEIVE_WHSE_EXCEPTIONS';
export const RECEIVE_OPCO_EXCEPTIONS = 'RECEIVE_OPCO_EXCEPTIONS';
export const SAVE_EXCEPTIONS = 'SAVE_EXCEPTIONS';
export const RECEIVE_EXCEPTIONS_SAVE_RESPONSE = 'RECEIVE_EXCEPTIONS_SAVE_RESPONSE';
export const DELETE_EXCEPTIONS = 'DELETE_EXCEPTIONS';
export const RECEIVE_EXCEPTIONS_DELETE_RESPONSE = 'RECEIVE_EXCEPTIONS_DELETE_RESPONSE';
export const FETCH_EXCEPTION_CODES = 'FETCH_EXCEPTION_CODES';
export const RECEIVE_EXCEPTION_CODES = 'RECEIVE_EXCEPTION_CODES';

export const REQUEST_AGREEMENT_NUMBERS = 'REQUEST_AGREEMENT_NUMBERS';
export const RECEIVE_AGREEMENT_NUMBERS = 'RECEIVE_AGREEMENT_NUMBERS';
export const REQUEST_AGREEMENT_DETAILS = 'REQUEST_AGREEMENT_DETAILS';
export const RECEIVE_AGREEMENT_DETAILS = 'RECEIVE_AGREEMENT_DETAILS';
export const CLONE_AGREEMENT = 'CLONE_AGREEMENT';
export const UPDATE_AGREEMENT = 'UPDATE_AGREEMENT';
export const CREATE_AGREEMENT = 'CREATE_AGREEMENT';
export const DELETE_AGREEMENT = 'DELETE_AGREEMENT';
export const RECEIVE_CREATE_AGREEMENT_RESPONSE = 'RECEIVE_CREATE_AGREEMENT_RESPONSE';
export const RECEIVE_CLONE_AGREEMENT_RESPONSE = 'RECEIVE_CLONE_AGREEMENT_RESPONSE';
export const RECEIVE_UPDATE_AGREEMENT_RESPONSE = 'RECEIVE_UPDATE_AGREEMENT_RESPONSE';
export const RECEIVE_DELETE_AGREEMENT_RESPONSE = 'RECEIVE_DELETE_AGREEMENT_RESPONSE';

export const RECALCULATE_AGREEMENT = 'RECALCULATE_AGREEMENT';
export const RECEIVE_RECALCULATE_AGREEMENT_RESPONSE = 'RECEIVE_RECALCULATE_AGREEMENT_RESPONSE';
export const DECLINE_RECALCULATION = 'DECLINE_RECALCULATION';
export const RECEIVE_RECALC_DECLINE_RESPONSE = 'RECEIVE_RECALC_DECLINE_RESPONSE';
export const POST_AGREEMENT_COMMENT = 'POST_AGREEMENT_COMMENT';
export const RECEIVE_COMMENT_WITH_ATTACHMENT = 'RECEIVE_COMMENT_WITH_ATTACHMENT';
export const RESET_AGREEMENT_DETAILS = 'RESET_AGREEMENT_DETAILS';
export const RESET_AGREEMENT_NUMBERS = 'RESET_AGREEMENT_NUMBERS';
export const FETCH_AGREEMENT_ASSOCIATED_VENDORS = 'FETCH_AGREEMENT_ASSOCIATED_VENDORS';

export const FETCH_ITEM_GROUPS = 'FETCH_ITEM_GROUPS';
export const RECEIVE_ITEM_GROUPS = 'RECEIVE_ITEM_GROUPS';
export const RECEIVE_ERROR_IN_ITEM_GROUPS = 'RECEIVE_ERROR_IN_ITEM_GROUPS';

export const REQUEST_ITEM_GROUP = 'REQUEST_ITEM_GROUP';
export const RECEIVE_ITEM_GROUP = 'RECEIVE_ITEM_GROUP';
export const RECEIVE_ERROR_IN_ITEM_GROUP_FETCH = 'RECEIVE_ERROR_IN_ITEM_GROUP_FETCH';

export const FETCH_VENDOR_ITEMS = 'FETCH_VENDOR_ITEMS';
export const RECEIVE_VENDOR_ITEMS = 'RECEIVE_VENDOR_ITEMS';
export const RECEIVE_VENDOR_ITEMS_FETCH_ERROR = 'RECEIVE_VENDOR_ITEMS_FETCH_ERROR';
export const UPDATE_ITEM_GROUP = 'UPDATE_ITEM_GROUP';
export const CREATE_ITEM_GROUPS = 'CREATE_ITEM_GROUPS';
export const RECEIVE_ITEM_GROUP_UPDATE_RESPONSE = 'RECEIVE_ITEM_GROUP_UPDATE_RESPONSE';
export const RECEIVE_ITEM_GROUP_UPDATE_ERROR = 'RECEIVE_ITEM_GROUP_UPDATE_ERROR';
export const RECEIVE_ITEM_GROUP_CREATE_RESPONSE = 'RECEIVE_ITEM_GROUP_CREATE_RESPONSE';
export const RECEIVE_ITEM_GROUP_CREATE_ERROR = 'RECEIVE_ITEM_GROUP_CREATE_ERROR';
export const DELETE_ITEM_GROUP = 'DELETE_ITEM_GROUP';
export const RECEIVE_ITEM_GROUP_DELETE_RESPONSE = 'RECEIVE_ITEM_GROUP_DELETE_RESPONSE';
export const RECEIVE_ITEM_GROUP_DELETE_ERROR = 'RECEIVE_ITEM_GROUP_DELETE_ERROR';

/**
 * Actions
 */
export const fetchAgreementData = (data) => ({ type: FETCH_AGREEMENT_DATA, data });
export const receiveAgreementData = (data) => ({ type: RECEIVE_AGREEMENT_DATA, data });
export const fetchAgreementList = (data) => ({ type: FETCH_AGREEMENT_LIST, data });
export const receiveAgreementList = (data) => ({ type: RECEIVE_AGREEMENT_LIST, data });

export const resetAgreementData = () => ({ type: RESET_AGREEMENT_DATA });
export const receiveErrorInAgreementFetch = (data) => ({ type: RECEIVE_ERROR_IN_AGREEMENT_FETCH, data });
export const resetErrorMessage = () => ({ type: RESET_ERROR_MESSAGE });

export const fetchAgreementsSearchData = (data) => ({ type: FETCH_AGREEMENTS_SEARCH_DATA, data });
export const receiveAgreementsSearchData = (data) => ({ type: RECEIVE_AGREEMENTS_SEARCH_DATA, data });
export const resetAgreementsSearchData = () => ({ type: RESET_AGREEMENTS_SEARCH_DATA });

export const fetchVendorBases = () => ({ type: FETCH_VENDOR_BASES });
export const fetchAgreementAssociatedVendors = (data) => ({ type: FETCH_AGREEMENT_ASSOCIATED_VENDORS, data });

export const receiveVendorBases = (data) => ({ type: RECEIVE_VENDOR_BASES, data });

export const fetchBusinessCenters = (data) => ({ type: FETCH_BUSINESS_CENTERS, data });
export const receiveBusinessCenters = (data) => ({ type: RECEIVE_BUSINESS_CENTERS, data });

export const fetchSASFDDetails = (data) => ({ type: FETCH_SAS_FD_DETAILS, data });
export const receiveSASFDDetails = (data) => ({ type: RECEIVE_SAS_FD_DETAILS, data });

export const saveSASValueForVendor = (data) => ({ type: SAVE_SAS_VALUE_FOR_VENDOR, data });
export const receiveSASValueUpdateStatus = (data) => ({ type: RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR, data });

export const requestSASFDFileImport = (data) => ({ type: REQUEST_SAS_FD_FILE_IMPORT, data });
export const receiveSASFDFileImport = (data) => ({ type: RECEIVE_SAS_FD_FILE_IMPORT, data });

export const addSASValueForVendor = (data) => ({ type: ADD_SAS_VALUE_FOR_VENDOR, data });
export const receiveSASValueAddStatus = (data) => ({ type: RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR, data });

export const saveSasFdDetailsForItems = (data) => ({ type: SAVE_SAS_FD_DETAILS_FOR_ITEM, data });
export const receiveSasFdDetailsForItems = (data) => ({ type: RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM, data });
export const requestAgreementNumbers = (data) => ({ type: REQUEST_AGREEMENT_NUMBERS, data });
export const receiveAgreementNumbers = (data) => ({ type: RECEIVE_AGREEMENT_NUMBERS, data });
export const resetAgreementNumbers = (data) => ({ type: RESET_AGREEMENT_NUMBERS, data });

export const requestAgreementDetails = (data) => ({ type: REQUEST_AGREEMENT_DETAILS, data });
export const resetAgreementDetails = (data) => ({ type: RESET_AGREEMENT_DETAILS, data });
export const receiveAgreementDetails = (data) => ({ type: RECEIVE_AGREEMENT_DETAILS, data });

export const updateAgreement = (data) => ({ type: UPDATE_AGREEMENT, data });
export const createAgreement = (data) => ({ type: CREATE_AGREEMENT, data });
export const cloneAgreement = (data) => ({ type: CLONE_AGREEMENT, data });
export const deleteAgreement = (data) => ({ type: DELETE_AGREEMENT, data });

export const receiveAgreementUpdateResponse = (data) => ({ type: RECEIVE_UPDATE_AGREEMENT_RESPONSE, data });
export const receiveAgreementCreateResponse = (data) => ({ type: RECEIVE_CREATE_AGREEMENT_RESPONSE, data });
export const receiveAgreementCloneResponse = (data) => ({ type: RECEIVE_CLONE_AGREEMENT_RESPONSE, data });
export const receiveAgreementDeleteResponse = (data) => ({ type: RECEIVE_DELETE_AGREEMENT_RESPONSE, data });

export const postAgreementComment = (data) => ({ type: POST_AGREEMENT_COMMENT, data });
export const receiveCommentWithAttachment = (data) => ({ type: RECEIVE_COMMENT_WITH_ATTACHMENT, data });

export const recalculateAgreement = (data) => ({ type: RECALCULATE_AGREEMENT, data });
export const receiveRecalculateResponse = (data) => ({ type: RECEIVE_RECALCULATE_AGREEMENT_RESPONSE, data });
export const declineRecalculation = (data) => ({ type: DECLINE_RECALCULATION, data });
export const receiveRecalcDeclineResponse = (data) => ({ type: RECEIVE_RECALC_DECLINE_RESPONSE, data });

export const clearAgreementDetails = (data) => ({ type: CLEAR_AGREEMENT_DETAILS, data });

export const requestItemGroups = (data) => ({ type: FETCH_ITEM_GROUPS, data });
export const receiveItemGroups = (data) => ({ type: RECEIVE_ITEM_GROUPS, data });
export const receiveErrorInItemGroups = (data) => ({ type: RECEIVE_ERROR_IN_ITEM_GROUPS, data });

export const requestItemGroup = (data) => ({ type: REQUEST_ITEM_GROUP, data });
export const receiveItemGroup = (data) => ({ type: RECEIVE_ITEM_GROUP, data });
export const receiveErrorInItemGroupFetch = (data) => ({ type: RECEIVE_ERROR_IN_ITEM_GROUP_FETCH, data });

export const fetchVendorItems = (data) => ({ type: FETCH_VENDOR_ITEMS, data });
export const receiveVendorItems = (data) => ({ type: RECEIVE_VENDOR_ITEMS, data });
export const receiveErrorInVendorItemsFetch = (data) => ({ type: RECEIVE_VENDOR_ITEMS_FETCH_ERROR, data });
export const updateItemGroup = (data) => ({ type: UPDATE_ITEM_GROUP, data });
export const createItemGroups = (data) => ({ type: CREATE_ITEM_GROUPS, data });
export const receiveItemGroupUpdateResponse = (data) => ({ type: RECEIVE_ITEM_GROUP_UPDATE_RESPONSE, data });
export const receiveItemGroupCreateResponse = (data) => ({ type: RECEIVE_ITEM_GROUP_CREATE_RESPONSE, data });
export const receiveItemGroupUpdateError = (data) => ({ type: RECEIVE_ITEM_GROUP_UPDATE_ERROR, data });
export const receiveItemGroupCreateError = (data) => ({ type: RECEIVE_ITEM_GROUP_CREATE_ERROR, data });

export const deleteItemGroup = (data) => ({ type: DELETE_ITEM_GROUP, data });
export const receiveItemGroupDeleteResponse = (data) => ({ type: RECEIVE_ITEM_GROUP_DELETE_RESPONSE, data });
export const receiveItemGroupDeleteError = (data) => ({ type: RECEIVE_ITEM_GROUP_DELETE_ERROR, data });

export const fetchExceptions = (data) => ({ type: FETCH_EXCEPTIONS, data });
export const receiveWhseExceptions = (data) => ({ type: RECEIVE_WHSE_EXCEPTIONS, data });
export const receiveOpcoExceptions = (data) => ({ type: RECEIVE_OPCO_EXCEPTIONS, data });
export const saveExceptions = (data) => ({ type: SAVE_EXCEPTIONS, data });
export const receiveExceptionsSaveResponse = (data) => ({ type: RECEIVE_EXCEPTIONS_SAVE_RESPONSE, data });
export const deleteExceptions = (data) => ({ type: DELETE_EXCEPTIONS, data });
export const receiveExceptionsDeleteResponse = (data) => ({ type: RECEIVE_EXCEPTIONS_DELETE_RESPONSE, data });
export const fetchExceptionCodes = (data) => ({ type: FETCH_EXCEPTION_CODES, data });
export const receiveExceptionCodes = (data) => ({ type: RECEIVE_EXCEPTION_CODES, data });
